/*
 * The studio's parent portal link (Bobbie, 2026-09-07, verbatim: "Please
 * add this as a link as a button for everyone and call it payment portal").
 * Renamed the same day (Bobbie: "Sorry name it the parent portal... they
 * know what that is").
 *
 * One constant, so the URL lives in exactly one place and every home surface
 * that mounts ParentPortalButton reads the same value. Nothing about what
 * the portal is for, or what it is used to pay, is invented here or in the
 * button copy - Bobbie gave us the link and the name, nothing else.
 */
export const PARENT_PORTAL_URL =
  'https://app.gostudiopro.com/online/index.php?account_id=8811';
